import React from 'react';

const Logo = ({ isDark = false }) => {
  return (
    <div className="flex items-center">
      <img 
        src="https://customer-assets.emergentagent.com/job_fit-innovation/artifacts/1gcbb55z_Logo.png" 
        alt="FITNOVEXA - Tech + Innovation" 
        className="h-16 md:h-20 lg:h-24 w-auto"
        style={{
          maxWidth: '100%',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default Logo;